import { apiClient } from "../../config";
import { env } from "../../../config/env";
import {
  GetProjectCategoriesResponse,
  GetProjectCategoryResponse,
  SuccessResponse
} from "../../interface/projectcategories.interface";

class AdminProjectCategoriesService {

  /**
   * 📦 GET ALL
   */
  async getProjectCategories(): Promise<GetProjectCategoriesResponse> {
    const response = await apiClient.get<GetProjectCategoriesResponse>(
      env.ADMIN_PROJECT_CATEGORIES_URL
    );

    return response.data;
  }

  /**
   * 📄 GET ONE
   */
  async getProjectCategory(id: string): Promise<GetProjectCategoryResponse> {
    const response = await apiClient.get<GetProjectCategoryResponse>(
      `${env.ADMIN_PROJECT_CATEGORIES_URL}/${id}`
    );

    return response.data;
  }

  /**
   * ➕ CREATE
   */
  async createProjectCategory(payload: FormData): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ADMIN_PROJECT_CATEGORIES_URL,
      payload
    );

    return response.data;
  }

  /**
   * ✏️ UPDATE
   */
  async updateProjectCategory(id: string, payload: any): Promise<SuccessResponse> {
    const response = await apiClient.put(
      `${env.ADMIN_PROJECT_CATEGORIES_URL}/${id}`,
      payload
    );

    return response.data;
  }

  /**
   * 🖼️ UPDATE IMAGE
   */
  async uploadImageProjectCategory(id: string, payload: FormData): Promise<SuccessResponse> {
    const response = await apiClient.post(
      `${env.ADMIN_PROJECT_CATEGORIES_URL}/${id}/image`,
      payload
    );

    return response.data;
  }

  /**
   * 🗑️ DELETE
   */
  async deleteProjectCategory(id: string): Promise<SuccessResponse> {
    const response = await apiClient.delete(
      `${env.ADMIN_PROJECT_CATEGORIES_URL}/${id}`
    );

    return response.data;
  }
}

export const adminProjectCategoriesService = new AdminProjectCategoriesService();